<template>
  <van-popup  v-model="isShow" position="right" class='popup'>
    <section class="filterPopup">
      <van-icon class="closeBtn" name="cross" @click="isShow = false"></van-icon>

      <!-- 品类 -->
      <div class="filterItem" v-if='navListIndexOf("category")'>
        <h3 class="f32">商品品类</h3>
        <ul>
          <li v-for="(data, dataIndex) in catogoryList"
              :key="dataIndex"
              :class="{'active':myCatogoryId === data.id}"
              @click="checkItem(data.id, 1)">{{data.name}}</li>
        </ul>
      </div>

      <!-- 品牌 -->
      <div class="filterItem" v-if='navListIndexOf("brand")'>
        <h3 class="f32">商品品牌</h3>
        <ul>
          <li v-for="(data, dataIndex) in brandList"
              :key="dataIndex"
              :class="{'active':brandId === data.id}"
              @click="checkItem(data.id, 2 ,data)">{{data.brandName}}</li>
        </ul>
        <h4 class="f28" @click="brandMoreShow = true">按首字母查询品牌<van-icon class="icon" name="arrow" /></h4>
      </div>

      <!-- 颜色 -->
      <div class="filterItem" v-if='navListIndexOf("color")'>
        <h3 class="f32">商品颜色</h3>
        <ul>
          <li v-for="(data, dataIndex) in colorList"
              :key="dataIndex"
              :class="{'active':colorId === data.id}"
              @click="checkItem(data.id, 3)">{{data.name}}</li>
        </ul>
      </div>

      <!-- 材质 -->
      <div class="filterItem" style='margin-bottom:100px' v-if='navListIndexOf("material")'>
        <h3 class="f32">商品材质</h3>
        <ul>
          <li v-for="(data, dataIndex) in materialList"
              :key="dataIndex"
              :class="{'active':materialId === data.id}"
              @click="checkItem(data.id, 4)">{{data.name}}</li>
        </ul>
      </div>

      <div class="g-fixed-bottom t_right">
        <button class="secondary" @click="reset">重置</button>
        <button class="primary" @click='submit'>确定</button>
      </div>
    </section>
    <van-popup  v-model="brandMoreShow" position="right" >
      <section class="brandPopup">
        <van-icon class="closeBtn" name="cross" @click="brandMoreShow = false"></van-icon>
        <div class="filterItem" v-for="(item, index) in brandMore" :key="index">
          <h3 class="f32">{{item.title}}</h3>
          <ul>
            <li v-for="(data, dataIndex) in item.items"
                :key="dataIndex"
                :class="{'active':brandId === data.id}"
                @click="checkItem(data.id, 2, data)">
              <img :src="data.brandLogo" align="middle">
              <div class="f28 bold">{{data.brandName}}</div>
            </li>
          </ul>
        </div>
      </section>
    </van-popup>
  </van-popup>
</template>

<script>
  import caseApi from '@/axios/case'
  export default {
    name: 'filterPopup',
    props: {
      categoryId: {
        type: Number
      },
      catogoryList:{
        type :Array
      },
      serviceId : {
        type : String,
        default : ''
      }
    },
    data () {
      return {
        brandMoreShow : false,
        isShow: false,
        colorList : [],
        colorId : '',
        myCatogoryId : '',
        brandList:[],
        brandId : '',
        materialList:[],
        materialId:'',
        brandMore: [],
        navList : [],
      }
    },
    watch: {
      selectIdObj: {
        handler () {
          // console.log(this.selectIdObj)
        },
        deep: true
      }
    },
    computed: {},
    created () {
      this.getColor();
      this.getBrand();
      this.getMaterial();
      this.getBrandMore();
      this.getNav();
    },
    mounted () {
     this.reset()
    },
    methods: {
      navListIndexOf(item){
        return this.navList.indexOf(item) == -1?false:true
      },
      getNav(){
        let serviceId = this.serviceId;
        caseApi.getSearchNav(serviceId).then((res)=>{
          this.navList = res;
        })
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      submit(){
        let params = {
          queryCategoryId : this.myCatogoryId,
          queryBrandId : this.brandId,
          queryColorId : this.colorId,
          queryMaterialId : this.materialId
        }
        console.log(params)
        this.$emit('submitSearch',params);
        this.hide();
      },
      getBrandMore(){
        caseApi.getBrandMore({}).then((res)=>{

          this.brandMore = res.en;
          
        })
      },
      getMaterial(){
        let params = {
          categoryId : this.categoryId
        }
        caseApi.getMaterial(params).then((res)=>{
          this.materialList = res;
        })
      },
      getBrand(){
        caseApi.getBrand().then((res)=>{
          this.brandList = res;
        })
      },
      getColor(){
        caseApi.getColor().then((res)=>{
          this.colorList = res;
        })
      },
      show () {
        this.isShow = true
      },
      hide(){
        this.isShow = false
      },
      checkItem (id, type ,data) {
        console.log(type)
        if(type == 1){
          this.myCatogoryId = id;
        }else if(type == 2){
          this.brandId = id;
          if(data){
            let tag = false;
            this.brandList.forEach((element)=>{
              if(element.id == id){
                tag = true;
              }
            })
            if(!tag){
              this.brandList.push(data);
            }
            this.brandMoreShow = false;
          }
        }else if(type == 3){
          this.colorId = id;
        }else if(type == 4){
          this.materialId = id;
        }
       
      },
      reset () {
        this.myCatogoryId = '';
        this.brandId = '';
        this.colorId = '';
        this.materialId = '';
      }
    }

  }
</script>

<style lang="scss" scoped>
  .primary{
    position: absolute;
    right: 30px;
    top:9px;
  }
  .secondary{
    position: absolute;
    right: 270px;
    top:14px;
  }
  .popup{
    height: 100%;
    overflow: scroll;
  }
  .van-popup{
    &--right {
      width: 100%;
      height: 100%;
    }
    .filterPopup,.categoryPopup{
      padding: 40px 30px 0px;
      height: 100%;
      overflow: scroll;
      // margin-bottom: 50px;
      .filterItem{
        margin-bottom: 40px;
        h3{
          line-height: 44px;
          margin-bottom: 30px;
        }
        ul{
          display: flex;
          flex-wrap: wrap;
          margin-right: -20px;
          li{
            width: 176px;
            padding: 0 20px;
            height: 56px;
            line-height: 56px;
            background: #f6f6f6;
            font-size: 28px;
            margin:0 20px 20px 0;
            text-align: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .active{
            background: $primary-color;
            color: $white-color;
          }
        }
        h4{
          line-height: 60px;
          color: $brand-color;
          .icon{
            vertical-align: middle;
          }
        }
      }
    }
    .closeBtn{
      position: absolute;
      right: 30px;
      top:45px;
      font-size: 32px;
    }
    .categoryPopup{
      padding: 40px 30px 0;
    }
    .brandPopup{
      padding: 40px 116px 0 30px;
      .filterItem{
        margin-bottom: 40px;
        h3{
          line-height: 44px;
          margin-bottom: 30px;
        }
        ul{
          li{
            padding: 8px 2px 12px;
            height: 66px;
            line-height: 66px;
            display: flex;
            border-bottom: $base-border;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            img{
              width: 83px;
              height: 66px;
              margin-right: 24px;
            }
          }
          .active{
          }
        }
      }
    }
    .g-fixed-bottom button{
      margin-left: 20px;
    }
  }

</style>
